import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { AlluraFormikErrorMessage } from 'components/formik/core/AlluraErrorMessage/AlluraFormikErrorMessage';
import { ChangeEvent, FocusEventHandler } from 'react';

type region = {
  NAME: string;
  ID: number;
  COUNTRY_ID: number;
};

type country = {
  NAME: string;
  ID: number;
};

interface AddressDropdownProps {
  options: country[] | region[];
  value: country | region;
  handleSelect: (e: ChangeEvent<{}>, newValue: country | null) => void;
  label: string;
  onBlur?: FocusEventHandler<HTMLDivElement>;
  disabled?: boolean;
  name: string;
}

const AddressDropdownSelect = ({
  options,
  value,
  handleSelect,
  label,
  onBlur = undefined,
  disabled = false,
  name,
}: AddressDropdownProps) => {
  return (
    <>
      <Autocomplete
        onBlur={onBlur}
        options={options}
        onChange={handleSelect}
        value={value}
        id={name}
        isOptionEqualToValue={option => option.NAME === value.NAME}
        getOptionLabel={option => option.NAME}
        renderInput={params => (
          <TextField {...params} label={label} variant="outlined" size="small" fullWidth name={name} />
        )}
        disabled={disabled}
      />
      <AlluraFormikErrorMessage fieldName={name} />
    </>
  );
};

export default AddressDropdownSelect;
